import updateOrderAction from "./updateOrderAction";
import getSurchargedCartAction from "./getSurchargedCartAction";

export const formatDate = (str) => {
    if(str) {
        const dateParts = str.split("-")
        return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    } else {
        return null;
    }
}

const setDeliveryDateAction = async (get, session, deliveryDate) => {
    const currentDate = formatDate(get().order?.DatePromised);
    const isSameDate = currentDate
        && currentDate.getDate() === deliveryDate.getDate()
        && currentDate.getFullYear() === deliveryDate.getFullYear()
    const returnVal = {};
    if(!isSameDate) {
        deliveryDate.setHours(12);
        await updateOrderAction(session, get, 'DatePromised', deliveryDate);
        const refreshedOrder = await getSurchargedCartAction(session, false, get);
        for(const k of Object.keys(refreshedOrder)) {
            returnVal[k] = refreshedOrder[k];
        }
    }
    const currentInput = get().input || {};
    console.log("setting deliveryDate")
    return {...returnVal, input: { ...currentInput, deliveryDate: deliveryDate }};
}

export default setDeliveryDateAction;